exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".noSchemaContent{margin:35px 0px}.noSchemaContent p{font-size:20px;color:#bcb8b8;margin:25px 0px}.noSchemaContent img{opacity:.8}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/schema/schema-list/custom-schema.component.scss
// module id = 1188
// module chunks = 0 2